module.exports = __webpack_public_path__ + "img/face.309e5afc.svg";